export default [["en-us", {
  "adi-logo": "Analog Devices Logo",
  "ember-aditools-page": {
    "card": {
      "checkbox-tooltip": "Toggle",
      "help-tooltip": "Click for help",
      "part-number-tooltip": "Click to select part"
    },
    "common": {
      "cancel": "Cancel",
      "close": "Close",
      "load": "Load",
      "ok": "OK",
      "open": "Open",
      "save": "Save",
      "select": "Select"
    },
    "dialogs": {
      "feedback": {
        "email": "EMail: ",
        "feedback": "Your Feedback",
        "give-feedback": "Tell us",
        "invitation": "Please let us know your opinion of this tool, good and bad.",
        "name": "Name: ",
        "optional": "(Optional)",
        "title": "Give us your feedback!"
      },
      "load": {
        "choose-button": "Choose File",
        "message": "Load a design from a file on your computer.",
        "no-file-selected": "No file selected.",
        "title": "Load Design"
      },
      "samples": {
        "add-button": "Add Selected Samples to Cart",
        "add-link": "Add to Order",
        "add-to-cart-column": "Add Sample to Cart",
        "model-column": "Device Model/Package",
        "part-column": "Device Name",
        "quantities-warning": "Analog Devices offers a limited amount of free samples to qualified customers. Due to the large demand for our product samples we ask that you limit your sample request to 2 pieces per part with a maximum of 4 parts per request within a 14 day time period. Should your design needs require additional product quantities, you can purchase them on the web through Buy Online, or you can contact one of our authorized distributors.",
        "title": "Order Samples",
        "unavailable-message": "Not available for sample"
      },
      "save": {
        "save-desc-error": "Please provide a Description",
        "save-desc-field": "Description",
        "save-name-error": "Please provide a Design Name",
        "save-name-field": "Design Name",
        "title": "Save Design"
      },
      "share": {
        "share-button": "Email",
        "share-design-information": "<p>To share a copy of your design, enter your name into the <b>Sender name</b> field. Then enter the email address of the recipients in the <b>Share design with</b> field.</p><p>The recipients will receive an email from Analog Devices with an attachment containing a ZIP archive of the shared design. All you have to do is extract the design from the ZIP file and upload it using the Load Design functionality of the application</p><p>This process creates a copy of the design for each recipient. If recipients choose to make edits on their copies, it will have no effect on your design you saved to your own computer.</p>",
        "share-dialog-ng-message": "Unable to share design. This is likely due to a server connection error. Please try again.",
        "share-dialog-ok-message": "Design has been shared",
        "share-duplicate-email": "Duplicate emails found",
        "share-email-empty-error": "Please enter an email address",
        "share-email-field": "Share design with",
        "share-email-format-error": "At least one of the email addresses you entered is invalid. Please correct and try again",
        "share-email-placeholder": "Email Address",
        "share-name-error": "Please provide a Design Name",
        "share-name-field": "Design Name",
        "share-sender-error": "Please provide a Sender Name",
        "share-sender-field": "Sender Name",
        "title": "Share My Design"
      },
      "system": {
        "application-busy": "Working...",
        "title": "Application Message"
      }
    },
    "footer": {
      "accessibility": "Accessibility",
      "cookie-settings": "Cookie Settings",
      "copyright-text": "1995 - 2025 Analog Devices, Inc. All Rights Reserved",
      "icp-id": "",
      "legal": "Legal and Risk",
      "privacy-policy": "Privacy Policy",
      "privacy-settings": "Privacy Settings",
      "sitemap": "Sitemap"
    },
    "header": {
      "applications": "Applications",
      "company": "Company",
      "design-center": "Design Center",
      "education": "Education",
      "parametric-search": "Parametric Search",
      "products": "Products",
      "spoken": {
        "homepage": "ADI Home Page",
        "sitelinks": "ADI Site Links"
      },
      "support": "Support"
    },
    "menubar": {
      "chinese": "简体中文",
      "english": "English",
      "help": "Help",
      "japanese": "日本語",
      "load": "Load Design",
      "save": "Save"
    },
    "studio": {
      "adcdriver": "ADC Driver",
      "dacebc": "DAC",
      "diamond": "In Amp",
      "filterwizard": "Analog Filter",
      "noise": "Noise",
      "photodiode": "Photodiode",
      "precisionstudio": "ADI<span class=''service-mark''>℠</span> Precision Studio",
      "signalchaindesigner": "Signal Chain",
      "simdds": "DDS",
      "spoken": {
        "studiolinks": "ADI Precision Studio Links"
      },
      "virteval": "Virtual Eval"
    },
    "toolbar": {
      "actions": "Actions"
    }
  },
  "expandedParameterView": {
    "bw": "BW (Hz)",
    "cmrr": "CMRR (dB)",
    "description": "Description",
    "expand": "Expand view",
    "iosMax": "Ios Max (A)",
    "isyMaxPerAmp": "ISupply per Amp (A)",
    "name": "Part Name",
    "new-window": "New window",
    "noiseDensity": "Noise Density (V/√Hz)",
    "summaryText": "'{count, plural, =0 {Displaying # of {total} op amps. Please check the filters provided.} other {Displaying # of {total} in amps.}}'",
    "validGains": "Valid Gains",
    "vos": "Vos RTI (V)"
  },
  "gridErrorMsg": {
    "errorMsg": "There are no In-Amps that are compatible with the settings in the left panel.  Adjust supply, gain, and input signal settings, and use the Diamond Plot view to ensure that the input signal is within the operating range of the In-Amp.",
    "post": "to post a question about your design specifications and The Diamond Plot Tool.",
    "site": "ez.analog.com/community/design-tools-and-calculators",
    "visit": "Visit"
  },
  "hamburgerMenu": {
    "applications": "Applications",
    "community": "Community",
    "designCenter": "Design Center",
    "education": "Education",
    "parametricSearch": "Parametric Search",
    "products": "Products",
    "support": "Support"
  },
  "headerIcons": {
    "feedback": "Feedback",
    "help": "Help",
    "share": "Share",
    "undo": "Return to 100%"
  },
  "help": {
    "help": {
      "header": "Using the Diamond Plot Tool",
      "message": "<div class=\"help-dialog--standard\"><h3 class=\"dialog-title\"><a href=\"{siteUrl}/{adiLocale}/product-category/instrumentation-amplifiers\" target=\"_blank\" rel=\"noopener noreferrer\">What is an in-amp?</a></h3><h3 class=\"dialog-title\"><a href=\"https://www.youtube.com/watch?v=VSf31DaXWUE\" target=\"_blank\" rel=\"noopener noreferrer\">I need more background about this graph</a> (video)<p></p></h3><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">What does this tool do?</h3></p><p>Instrumentation amplifier datasheets typically show a graph (or several variations) of the Output Swing vs Input Common-Mode Voltage, also known as the <b>Diamond Plot</b>, which is a comprehensive graph of all external and internal headroom limits. Given enough basic information about a circuit, the <b>Diamond Plot</b> can be adjusted for various Supply Voltages, Gains, and Reference Pin Voltages</p><p>Although this adjusted plot itself is good information, the real value is in determining whether or not the signal of interest is within the <b>Diamond Plot</b> limits. This requires having the input signal information as well. The input signal range is plotted directly on the <b>Diamond Plot</b> and any errors where the input signal crosses the <b>Diamond Plot</b> boundaries are shown on the plot and are reported by the tool.</p><p>For any circuit configuration, the tool keeps a list of <b>Recommended</b> In-Amps. These <b>Recommended</b> parts meet the <b>Diamond Plot</b> requirements as well as Supply Voltage Range, REF pin voltage range, and Gain Range, so that they will work in the circuit as-described. This list can be filtered further within the tool or in the parametric table on analog.com. Using this tool during a design, in-amps can be selected within minutes, not hours, and with a high degree of confidence.</p><p>Finally, a simplified version of the <b>Internal Circuitry</b> is available for those who are curious about the inner workings of the in-amps and in finding specifically what is saturated. Sliders are available to adjust the voltage displayed across the entered signal range.</p><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">How do I use this tool?</h3></p><p><ins>Set up</ins>: In the <b>Circuit Configuration</b> Panel, choose a product from the drop-down list and enter the circuit conditions, such as supply voltage, reference pin voltage, and gain. Enter the input signal range, including any expected variations due to component tolerance and common-mode or differential offsets that must be accounted for in the design.</p><p><ins>Input Signal</ins>: Input common mode voltage is defined as the average of the two input voltages: V<sub>CM</sub> = (V<sub>+IN</sub> + V<sub>-IN</sub>) / 2. Therefore single-ended input signals, in which the voltage at one input is fixed and the other is varied, will change the common-mode voltage along with the differential voltage. In the drop-down, choose whether the input signal is fully differential or single-ended. And if single ended, is it the positive input which is varying, for example, a thermocouple with the negative lead grounded, or is it the negative input which varies, for example, sensing high-side current on a smaller voltage rail.</p><p><ins>Next Steps</ins>: If there are errors in the circuit, the tool shows them. There may be alternative products which do work, which are shown in the <b>Recommended tab</b> and also visible in the product selection drop-down menu. Otherwise, adjust the circuit until you arrive at a working configuration.</p><p>If selecting a product, use the <b>Recommended</b> tab to filter and sort the <b>Recommended</b> list. Access the product pages and datasheets through the provided links.</p><p>If using the <b>Internal Circuitry</b> tab, move the sliders to adjust the common-mode and differential voltage of the display point to any voltage in the Input Signal range.</p></div>"
    },
    "importantShapes": {
      "header": "How do I use this graph?",
      "message": "<div class=\"help-dialog--standard\"><p>There are many shapes and boundaries illustrated in the Diamond Plot of this tool.  This collection of shapes can be distilled into two groups – the Operating Range, and the Device Limits.</p><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">Operating Range</h3></p><p>In the Diamond Plot, the Operating Range is represented by drawing a box around all of the voltages where the circuit is expected to operate.  The limits of the Operating Range are calculated from the input signal and the gain of the in-amp.  It is plotted across two axes – the common mode voltage (Vcm) vs. the output voltage (Vout).   Both of these values can be plotted as a range (min and max values), or as a single value.   This shape is red in the Diamond Plot Tool.</p><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">Device Limits</h3></p><p>The remaining shapes on the Diamond Plot represent the operating limits of the device.  Each shape represents the limits of a specific portion of the selected in-amp, and the area on the plot where all of these shapes overlap indicates the Vcm vs. Vout region where the selected devices will operate properly.</p><p>This \"valid\" operating region is white in on the Diamond Plot tool, while the \"invalid\" operating region is grey.</p><p>When the Operating Range shape (red) is within the boundaries of the valid operating region (white area), this indicates that the selected device, with the specified conditions (supply voltage, reference voltage, gain, input signal) will operate as expected.</p><p>When the Operating Range shape falls outside of the valid operating region (and extends into the grey area), this indicates that the selected device will not operate as expected, given the specified supply voltage, reference voltage, gain, and input signal.</p></div>",
      "popupLink": "How do I use this graph?"
    },
    "share": {
      "blog": "Instrumentation Amplifier support community",
      "copy": "Copied ",
      "copyFail": "Copying failed ",
      "copyToClipboard": "Copy to clipboard",
      "p1": "1. Copy this link to your clipboard",
      "p2": "2. Paste it into an email, EngineerZone® forum or a social media post",
      "subHeader1": "Sharing This In-Amp Configuration Is Easy!",
      "subHeader2": "Want in-amp tips? Check out EngineerZone®"
    }
  },
  "inputMain": {
    "circuitHeader": "CIRCUIT CONFIGURATION",
    "done": "Done",
    "enable": "Enable range",
    "gain": {
      "default": "Gain",
      "input": "Input Gain",
      "output": "Output Scaling Gain",
      "total": "Total Gain = "
    },
    "gainFixed": "Fixed gain",
    "reset": "Default settings",
    "signalHeader": "Input Signal",
    "to": "to",
    "vclhi": "CLHI",
    "vcllo": "CLLO",
    "vdiff": "Vdiff:",
    "voltage": "V",
    "vref": "Vref",
    "vref1": "REF1",
    "vref2": "REF2",
    "vsn": "-Vs",
    "vsp": "+Vs"
  },
  "internalCircuitry": {
    "vDiff": "Vdiff = ",
    "vNeg": "V-",
    "vPos": "V+",
    "vPosOut": "V+OUT",
    "voltage": "V"
  },
  "internalValidation": {
    "error_subtractIn_high": "{type} falls outside of the subtractor high limit of: {high}",
    "error_subtractIn_low": "{type} falls outside of the subtractor low limit of: {low}",
    "error_vIH": "{type} falls outside of the vIH limit of: {vIH}",
    "error_vIL": "{type} falls outside of the vIL limit of: {vIL}",
    "error_vOH": "{voutLabel} falls outside of the vOH limit of: {vOH}",
    "error_vOL": "{voutLabel} falls outside of the vOL limit of: {vOL}",
    "error_vinGainMax_high": "{type} falls outside of the pre amp high limit of: {preAmpHigh}",
    "error_vinGainMin_low": "{type} falls outside of the pre amp low limit of: {preAmpLow}"
  },
  "legend": {
    "differentailLimits": "Differential Input Limits",
    "feedbackLimits": "Feedback Pin Limits",
    "inputLimits": "Input Pin Limits",
    "internalLimits": "Internal Node Limits",
    "legend": "Legend",
    "operatingRange": "Operating Range",
    "outputLimits": "Output Pin Limits",
    "outputPinA1": "Output Pin & A1 Limits"
  },
  "modals": {
    "close": "Close",
    "feedback": {
      "cancel": "Cancel",
      "email": "EMail: ",
      "feedback": "Your Feedback",
      "feedbackDialogNgMessage": "Failed to send user feedback. This may be due to a poor connection to the server. Please try again.",
      "feedbackDialogOkMessage": "Your feedback has been sent.",
      "give-feedback": "Tell us",
      "header": "Give us your feedback!",
      "id": "feedback-survey",
      "invitation": "Please let us know your opinion of this tool, good and bad.",
      "name": "Name: ",
      "optional": "(Optional)"
    },
    "plot-boundaries": {
      "header": "Plot boundaries have failed",
      "message": "Please send feedback that you received this message and include the current url."
    },
    "system": {
      "applicationBusy": "Working...",
      "header": "Application Message"
    }
  },
  "new-window": "New Window",
  "operatingRangeValidation": {
    "error_polygons": "The {partNumber} is not operating within the supply limits - an internal node voltage is exceeding the available supply. Try the following:<ul><li> reduce the input signal </li><li> increase the supply </li><li> reduce the gain </li></ul>"
  },
  "partSelector": {
    "gain": "Not compatible with gain entered",
    "range": "Input signal exceeds device operating range",
    "supply": "Not compatible with supply range entered",
    "vref": "Vref entered exceeds supply margins of device"
  },
  "plotXLabel": "Vout (V) (typical limits at 25C)",
  "plotXLabelDiff": "Vout Diff (V) (typical limits at 25C)",
  "plotXLabelDiff3Amp": "Vout Diff (V)",
  "plotYLabel": "Vcm (V)",
  "recommendedInAmps": {
    "all": "all in-amps",
    "description": "Description",
    "expandView": "Filter this list by specifications",
    "expandedParametricView": "Expanded Parametric View",
    "fixedAndProg1": "Fixed and Programmable in-amps can achieve very high gain accuracy and low gain drift",
    "fixedAndProg2": "but they will only appear in this list if the exact gain is chosen. Fixed gains available:",
    "fixedAndProg3": "1, 2, 4, 5, 8, 10, 16, 32, 64, 100, 128, 2000",
    "name": "Part",
    "partsWithGain": "Specifications estimated based on gain of ",
    "recommended": "recommended in-amps",
    "recommendedAmps": "Recommended in-amps, based on settings specified in left panel",
    "reset": "Reset",
    "viewParametrics": "View parametrics for ",
    "volts": "V/V"
  },
  "schematicOutput": {
    "rg": "Rg",
    "to": " to ",
    "v": "V",
    "vcm": "Vcm",
    "vdiff": "Vdiff",
    "vdiff2": "Vdiff/2",
    "vn": "Vn",
    "vout": "Calculated Vout",
    "voutdiff": "Calculated Vout(diff)",
    "vp": "Vp"
  },
  "schematicValidation": {
    "emptyString": "the value must not be empty",
    "error_avss_vs_dvss": "{outVsmLabel} must be at the same voltage as DVSS. See \"Power Supplies\" and \"ESD Map\" section of {partNumber} datasheet.",
    "error_avss_vs_vddh": "Please adjust the supply values. {outVsmLabel} should not be more than 30V below {inVspLabel}.",
    "error_avss_vs_vssh": "Please adjust the supply values. {outVsmLabel} should not be more than 30V above {inVsmLabel}.",
    "error_gain": "Please adjust the gain value. The gain must be within the specified gain limits of the {partNumber}, {bottomRange} to {topRange}",
    "error_output_supply_range": "Please adjust the supply values. The supply range ({outVspLabel} - {outVsmLabel}) must be within the specified supply range limits of the {partNumber} - {minRange}V to {maxRange}V",
    "error_vcms": "The {partNumber} is not operating within the supply limits - the input voltage is exceeding the available supply. Try the following:<ul><li> reduce the input signal </li><li> increase the supply </li></ul>",
    "error_vddcp": "Please adjust the supply values. {vddcpLabel} must be within the specified supply range limits of the {partNumber} - {min}V to {max}V",
    "error_voltage_supplies": "Please adjust the supply values. The supply range ({vsPosLabel} - {vsNegLabel}) must be within the specified supply range limits of the {partNumber} - {minRange}V to {maxRange}V",
    "error_vouts": "The {partNumber} is not operating within the supply limits - Output voltage is exceeding the available supply. Try the following: <ul> <li> reduce the input signal </li> <li> reduce the gain </li> <li> increase the supply </li><li> change the {vrefLabel} value </li></ul>",
    "error_vposout_vs_vposin": "Please adjust the supply values. {vPosOutLabel} must be equal to or lower than {vPosInLabel}",
    "error_vref": "Please adjust the {vrefLabel} value. For the {partNumber}, with supply values of {vsPosLabel} = {vsTop}V and {vsNegLabel} = {vsBottom}V, {vrefLabel} must be within {minRange}V and {maxRange}V",
    "error_vref_pins": "Please adjust the REF pin values. (REF2 - REF1) should not be more than {vrefSpan}V",
    "gainValOne": "Please adjust the gain value. The gain must be one of the allowed gain values of the {partNumber}",
    "invalidChar": "the value must be a number",
    "recommendedOne": "change in amp: ",
    "recommendedTwo": " parts recommended"
  },
  "signalConfig": {
    "v": "V"
  },
  "tabs": {
    "internal": "Internal Circuitry",
    "polygon": "Diamond Plot",
    "recommended": "Recommended",
    "test": "Test"
  },
  "test": {
    "againstGold": "Validate Against Gold",
    "generateGold": "Generate Gold Standard"
  },
  "title": "Instrumentation Amplifier Diamond Plot Tool",
  "typeDifferential": "Vcm",
  "typeDifferentialDescription": "Differential",
  "typeSingleEndedNeg": "Vp",
  "typeSingleEndedNegDescription": "Single-ended V-",
  "typeSingleEndedPos": "Vn",
  "typeSingleEndedPosDescription": "Single-ended V+"
}], ["ja-jp", {
  "adi-logo": "Analog Devices Logo",
  "ember-aditools-page": {
    "card": {
      "checkbox-tooltip": "Toggle",
      "help-tooltip": "Click for help",
      "part-number-tooltip": "Click to select part"
    },
    "common": {
      "cancel": "キャンセル",
      "close": "閉じる",
      "load": "読み込む",
      "ok": "OK",
      "open": "開く",
      "save": "保存する",
      "select": "選ぶ"
    },
    "dialogs": {
      "feedback": {
        "email": "お客様のメールアドレス：",
        "feedback": "ご意見、ご要望：",
        "give-feedback": "意見または感想を送る",
        "invitation": "このツールに関する率直なご意見、ご要望をお聞かせください。 ",
        "name": "お客様のお名前：",
        "optional": "(Optional)",
        "title": "皆様のご意見をお聞かせください！"
      },
      "load": {
        "choose-button": "ファイルを選択",
        "message": "ローカルPC上の設計ファイルを読み込む",
        "no-file-selected": "No file selected.",
        "title": "設計を読み込む"
      },
      "samples": {
        "add-button": "選択したサンプルをカートに入れる",
        "add-link": "Add to Order",
        "add-to-cart-column": "サンプルをカートに入れる",
        "model-column": "モデル／パッケージ",
        "part-column": "構成部品",
        "quantities-warning": "アナログ・デバイセズは認証させていただいたお客様に限り、無料サンプルのご注文を受け付けています。 サンプルについては大変多くのご要望をいただいておりますため、おひとり様2週間あたり最大で4製品、各2個ずつまでのご注文とさせていただきます。無料サンプルとしてご注文いただける以上の量が必要な場合は、オンライン購入をしていただくか（在庫がある場合に限ります）、販売代理店にお問い合わせください。",
        "title": "サンプル注文",
        "unavailable-message": "サンプルの提供はありません。"
      },
      "save": {
        "save-desc-error": "概要を入力してください。",
        "save-desc-field": "概要",
        "save-name-error": "デザイン名を入力してください。",
        "save-name-field": "デザイン名",
        "title": "保存"
      },
      "share": {
        "share-button": "Email",
        "share-design-information": "<p>設計ファイルのコピーを共有するには、<b>“差出人名”</b>にお客様のお名前を、共有したい方のメールアドレスを<b>“設計を共有”</b>項目にご入力ください。送信先が複数の場合には、それぞれのメールアドレスを改行してご入力ください。</p><p>アナログ･デバイセズよりZIPファイルにまとめられた設計ファイルが添付されたメールを、ご入力いただいたメールアドレスにお送りします。添付されたZIPファイルを解凍して、各ツールのアップロード機能を使用して設計ファイルをアップロードするだけで、その設計ファイルを使用することが出来ます。</p><p>上記手順により、共有された設計ファイルのコピーを使用することが出来ます。ただし、共有された設計ファイルのコピーが編集されても、お客様のオリジナルの設計ファイルが編集されることはありません。</p>",
        "share-dialog-ng-message": "回路を共有できません。サーバーの接続不良による可能性があります。再度お試しください。",
        "share-dialog-ok-message": "回路は共有されました",
        "share-duplicate-email": "同じメールアドレスが複数含まれています",
        "share-email-empty-error": "メールアドレスを入力してください。",
        "share-email-field": "設計を共有",
        "share-email-format-error": "お客様が入力したメールアドレスの中で少なくとも１つは無効です。修正して再度お試しください。",
        "share-email-placeholder": "メールアドレス",
        "share-name-error": "デザイン名を入力してください。",
        "share-name-field": "デザイン名",
        "share-sender-error": "差出人名を入力してください。",
        "share-sender-field": "差出人名",
        "title": "自分の設計をメールで送信"
      },
      "system": {
        "application-busy": "処理中・・・",
        "title": "アプリケーション・メッセージ"
      }
    },
    "footer": {
      "accessibility": "アクセシビリティ",
      "cookie-settings": "Cookieの設定",
      "copyright-text": "1995 - 2025 Analog Devices, Inc. 全著作権所有",
      "icp-id": "",
      "legal": "法的事項およびリスク約",
      "privacy-policy": "プライバシーポリシー",
      "privacy-settings": "プライバシー設定",
      "sitemap": "サイトマップ"
    },
    "header": {
      "applications": "アプリケーション",
      "company": "企業情報",
      "design-center": "設計支援",
      "education": "調べる／学ぶ",
      "parametric-search": "パラメータ検索",
      "products": "製品",
      "spoken": {
        "homepage": "ホームページ",
        "sitelinks": "アナログ・デバイセズのサイトへのリンク"
      },
      "support": "サポート"
    },
    "menubar": {
      "chinese": "简体中文",
      "english": "English",
      "help": "ヘルプ",
      "japanese": "日本語",
      "load": "設計を読み込む",
      "save": "保存"
    },
    "studio": {
      "adcdriver": "ADCドライバ",
      "dacebc": "DAC",
      "diamond": "計装アンプ",
      "filterwizard": "アナログ・フィルタ",
      "noise": "ノイズ",
      "photodiode": "フォトダイオード",
      "precisionstudio": "ADI<span class=''service-mark''>℠</span> Precision Studio",
      "signalchaindesigner": "Signal Chain",
      "simdds": "DDS",
      "spoken": {
        "studiolinks": "ADI Precision Studio へのリンク"
      },
      "virteval": "Virtual Eval"
    },
    "toolbar": {
      "actions": "Actions"
    }
  },
  "expandedParameterView": {
    "bw": "BW (Hz)",
    "cmrr": "CMRR (dB)",
    "description": "説明",
    "expand": "拡張表示",
    "iosMax": "Ios Max (A)",
    "isyMaxPerAmp": "アンプごとの ISupply（A）",
    "name": "部品",
    "new-window": "新しいウィンドウ",
    "noiseDensity": "ノイズ密度（nV/√Hz）",
    "summaryText": "'{count, plural, =0 {{total}製品中#個のアンプを表示しています。設定されたフィルターをご確認ください。} other {{total}製品中#個のアンプを表示しています。}}'",
    "validGains": "有効ゲイン",
    "vos": "Vos RTI (V)"
  },
  "gridErrorMsg": {
    "errorMsg": "左で指定された仕様と互換性のある計装アンプはありません。電源電圧、ゲイン、入力信号の仕様を調整し、ダイヤモンド・プロット・ビューを使用して入力信号が計装アンプの動作範囲内になっていることを確認してください。",
    "post": "をご覧ください。",
    "site": "ez.analog.com/community/design-tools-and-calculators",
    "visit": "設計仕様やダイヤモンド・プロット・ツールに関するご質問がある場合は、"
  },
  "hamburgerMenu": {
    "applications": "アプリケーション",
    "community": "コミュニティ",
    "designCenter": "デザインセンター",
    "education": "調べる ／ 学ぶ",
    "parametricSearch": "パラメータ検索",
    "products": "製品",
    "support": "サポート"
  },
  "headerIcons": {
    "feedback": "フィードバック",
    "help": "ヘルプ",
    "share": "共有",
    "undo": "100 % に戻す"
  },
  "help": {
    "help": {
      "header": "ダイヤモンド・プロット・ツールの使用について",
      "message": "<div class=\"help-dialog--standard\"><h3 class=\"dialog-title\"><a href=\"{siteUrl}/{adiLocale}/product-category/instrumentation-amplifiers\" target=\"_blank\" rel=\"noopener noreferrer\">計装アンプとは？</a></h3><h3 class=\"dialog-title\"><a href=\"https://www.youtube.com/watch?v=VSf31DaXWUE\" target=\"_blank\" rel=\"noopener noreferrer\">このグラフの詳細な背景情報が知りたい</a> (video)<p></p></h3><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">このツールは何をするためのものなのか？</h3></p><p>通常、計装アンプ・データシートには、ダイヤモンド・プロットとも呼ばれる構成固有の出電圧範囲圧対入力コモンモード電圧のグラフ（またはいくつかのバリエーション）が記載されています。これは、すべての外部および内部ヘッドルーム制限の包括的なグラフです。回路に関する十分な基本情報があれば、さまざまな電源電圧、ゲイン、およびリファレンス・ピン電圧に合わせてダイヤモンド・プロットを調整できます。</p><p>この調整されたプロット自体も有効な情報ですが、実際の価値は、注目する信号がダイヤモンド・プロットの制限内にあるかどうかを判断できる点にあります。これには、入力信号情報も必要になります。入力信号範囲は、ダイヤモンド・プロット上に直接プロットされ、入力信号がダイヤモンド・プロットの境界を超えるようなエラーがプロット上に表示され、ツール上でエラーを知ることが出来ます。</p><p>ツールは、すべての回路構成に対して推奨される計装アンプ製品のリストを表示します。これらの推奨されるパーツは、ダイヤモンド・プロット、電源電圧範囲、REF ピン電圧範囲、ゲイン範囲の要件を満たすので、回路内で仕様どおりに機能します。このリストは、ツールでさらにフィルタを適用するか、analog.com のパラメータ・テーブルでさらに絞り込むことができます。設計中にこのツールを使用すると、わずか数分以内に自信を持って計装アンプを選ぶことが出来ます。</p><p>計装アンプの内部の仕組みおよび具体的な飽和原因を見つける方法を知りたいユーザー向けに内部回路を単純化した図が表示されます。スライダーを使用して、入力した信号範囲で表示される電圧を調整できます。</p><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">このツールの使用方法</h3></p><p>セットアップ: 回路構成パネルで、ドロップダウン・リストから製品を選び、電源電圧、ゲイン、リファレンス・ピン電圧などの回路の条件を入力します。部品の許容誤差やコモンモード／差動オフセットによって発生し、設計時に考慮する必要があるバリエーションをすべて含む入力信号範囲を入力します。</p><p>入力信号:入力コモンモード電圧は、次のように 2 つの入力電圧の平均として定義されます。VCM = (V+IN + V-IN) / 2。そのため、1 つの入力の電圧が固定で、他の入力が変化しているシングルエンド入力信号は、差動電圧とともにコモンモード電圧を変化させます。プルダウンから、入力信号が完全差動かシングルエンドかを選択します。シングルエンドの場合、変化しているのが正入力か（例えば、負のリード線がグラウンドされた熱電対）、負入力か（例えば、小型の電圧レール上のハイサイド電流検出）を選択します。</p><p>次のステップ:回路内にエラーがある場合は、ツールでエラーが表示されます。機能する代替製品がある場合は、［推奨］タブにその製品が表示され、製品選択ドロップダウンメニューにも表示されます。それ以外の場合は、動作可能な構成になるまで回路を調整します。</p><p>製品を選択した場合は、［推奨］タブを使用して、フィルタを適用し、［推奨］リストを並べ替えます。表示されるリンクから製品ページとデータシートにアクセスすることが出来ます。</p><p>［内部回路］タブを使用する場合、スライドを動かして、表示されるコモンモード電圧および差動電圧が入力信号範囲内の電圧になるように調整します。</p></div>"
    },
    "importantShapes": {
      "header": "グラフの使用方法",
      "message": "<div class=\"help-dialog--standard\"><p>このツールのダイヤモンド・プロットには多くの図形と境界が描画されます。この図形の集まりは、動作範囲とデバイス制限という 2 つのグループに分類できます。</p><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">動作範囲</h3></p><p>ダイヤモンド・プロットで、動作範囲は、回路が動作すると予想されるすべての電圧の周囲にボックスを描画することで表されます。動作範囲の制限は、計装アンプの入力信号とゲインから計算され、2 つの軸（コモンモード電圧（Vcm）対出力電圧（Vout））上にプロットされます。   これらの両方の値を範囲として（最小値と最大値）または単一の値としてプロットできます。   この図形はダイヤモンド・プロット・ツールでは赤で表示されます。</p><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">デバイス制限</h3></p><p>ダイヤモンド・プロット上の残りの図形は、デバイスの動作制限を表します。各図形は、選択した計装アンプの特定の部分の制限を表し、これらのすべての図形が重なるプロット上の領域は、選択したデバイスが適切に動作する Vcm と Vout の領域を示します。</p><p>この「有効な」動作領域は、ダイヤモンド・プロット・ツールで白色に表示され、「無効な」動作領域はグレーで表示されます。</p><p>動作範囲の図形（赤）が有効な動作領域（白の領域）の境界内にある場合は、選択したデバイスが指定された条件（電源電圧、リファレンス電圧、ゲイン、入力信号）で正常に動作することを示しています。</p><p>動作範囲の図形が有効な動作領域の外側にある（灰色の領域内にはみ出している）場合は、選択したデバイスが、指定した電源電圧、リファレンス電圧、ゲイン、入力信号で予想通りに動作しないことを示しています。</p></div>",
      "popupLink": "グラフの使用方法"
    },
    "share": {
      "blog": "計装アンプ・サポート・コミュニティ",
      "copy": "Copied ",
      "copyFail": "Copying failed ",
      "copyToClipboard": "クリップボードにコピー",
      "p1": "1.このリンクをクリップボードにコピーします。",
      "p2": "2.メール、EngineerZone® フォーラム、SNSの投稿にリンクを貼り付けます。",
      "subHeader1": "この計装アンプの構成は簡単に共有できます。",
      "subHeader2": "計装アンプに関するヒントが必要な場合は、EngineerZone® をご参照ください。"
    }
  },
  "inputMain": {
    "circuitHeader": "回路構成",
    "done": "Done",
    "enable": "有効レンジ",
    "gain": {
      "default": "ゲイン",
      "input": "入力ゲイン",
      "output": "出力スケーリング・ゲイン",
      "total": "トータル・ゲイン = "
    },
    "gainFixed": "固定ゲイン",
    "reset": "初期設定に戻す",
    "signalHeader": "入力信号",
    "to": "to",
    "vclhi": "CLHI",
    "vcllo": "CLLO",
    "vdiff": "Vdiff:",
    "voltage": "V",
    "vref": "Vref",
    "vref1": "REF1",
    "vref2": "REF2",
    "vsn": "-Vs",
    "vsp": "+Vs"
  },
  "internalCircuitry": {
    "vDiff": "Vdiff = ",
    "vNeg": "V-",
    "vPos": "V+",
    "vPosOut": "V+OUT",
    "voltage": "V"
  },
  "internalValidation": {
    "error_subtractIn_high": "{type}は、サブストラクタの上限以上：{high}",
    "error_subtractIn_low": "{type}は、サブストラクタの下限以下：{low}",
    "error_vIH": "{type}がvIH動作領域の外側：{vIH}",
    "error_vIL": "{type}がvIL動作領域の外側：{vIL}",
    "error_vOH": "{voutLabel}がvOH動作領域の外側：{vOH}",
    "error_vOL": "{voutLabel}がvOL動作領域の外側：{vOL}",
    "error_vinGainMax_high": "{type}がプリアンプ動作領域の上限以上：{preAmpHigh}",
    "error_vinGainMin_low": "{type}がプリアンプ動作領域の下限以下{preAmpLow}"
  },
  "legend": {
    "differentailLimits": "差動入力制限",
    "feedbackLimits": "フィードバック・ピン制限",
    "inputLimits": "入力ピン制限",
    "internalLimits": "内部ノード制限",
    "legend": "凡例",
    "operatingRange": "動作範囲",
    "outputLimits": "出力ピン制限",
    "outputPinA1": "出力ピンおよび A1 制限"
  },
  "modals": {
    "close": "閉じる",
    "feedback": {
      "cancel": "キャンセル",
      "email": "お客様のメールアドレス：",
      "feedback": "ご意見、ご要望：",
      "feedbackDialogNgMessage": "フィードバックの送信に失敗しました。ネットワーク接続に問題がある場合があります。お手数ですが再度お試しください。",
      "feedbackDialogOkMessage": "ご意見、ご要望をご記入頂きありがとうございました。",
      "give-feedback": "意見または感想を送る",
      "header": "皆様のご意見をお聞かせください！",
      "id": "feedback-survey",
      "invitation": "このツールに関する率直なご意見、ご要望をお聞かせください。 ",
      "name": "お客様のお名前：",
      "optional": "(Optional)"
    },
    "plot-boundaries": {
      "header": "プロット境界に不具合があります。",
      "message": "受信したこのメッセージと現在のURLをご連絡ください。"
    },
    "system": {
      "applicationBusy": "処理中・・・",
      "header": "アプリケーション・メッセージ"
    }
  },
  "new-window": "新しいウィンドウ",
  "operatingRangeValidation": {
    "error_polygons": "{partNumber} は指定の電源電圧で動作しません。内部ノード電圧が使用可能な電源電圧を超えています。下記をお試しください。<ul><li> 入力信号を減らす </li><li> 電源電圧を増やす </li><li> ゲインを減らす </li></ul>"
  },
  "partSelector": {
    "gain": "指定したゲインと互換性がありません",
    "range": "入力信号がデバイスの動作範囲を超えています",
    "supply": "指定した電源電圧範囲と互換性がありません",
    "vref": "指定した Vref がデバイスの電源電圧マージンを超えています"
  },
  "plotXLabel": "Vout (V) (25C での一般的な制限)",
  "plotXLabelDiff": "Vout Diff (V) (25C での一般的な制限)",
  "plotXLabelDiff3Amp": "Vout Diff (V)",
  "plotYLabel": "Vcm (V)",
  "recommendedInAmps": {
    "all": "すべての計装アンプのパラメータを表示する",
    "description": "概要",
    "expandView": "下記リストに条件を追加する",
    "expandedParametricView": "展開したパラメータ・ビュー",
    "fixedAndProg1": "固定ゲイン／可変ゲイン計装アンプはゲインとゲイン・ドリフトが大変高精度ですが、",
    "fixedAndProg2": "この性能は設定された内部ゲインを使用する場合に限ります。",
    "fixedAndProg3": "1, 2, 4, 5, 8, 10, 16, 32, 64, 100, 128, 2000",
    "name": "製品",
    "partsWithGain": "",
    "recommended": "推奨計装アンプのパラメータを表示する",
    "recommendedAmps": "左で指定した仕様を基に推奨される計装アンプ一覧",
    "reset": "リセット",
    "viewParametrics": "",
    "volts": "V/V のゲインを基にして見積もられた仕様"
  },
  "schematicOutput": {
    "rg": "Rg",
    "to": " to ",
    "v": "V",
    "vcm": "Vcm",
    "vdiff": "Vdiff",
    "vdiff2": "Vdiff/2",
    "vn": "Vn",
    "vout": "計算した Vout",
    "voutdiff": "Vout(diff) の計算値",
    "vp": "Vp"
  },
  "schematicValidation": {
    "emptyString": "この欄は空白不可",
    "error_avss_vs_dvss": "{outVsmLabel}は、DVSSと同じ電圧でなければなりません。{partNumber}データシートの\"Power Supplies\"と\"ESD Map\"の項を参照してください。",
    "error_avss_vs_vddh": "電源電圧を調整してください。{outVsmLabel}は、{inVspLabel}より30V以上低くてはいけません。",
    "error_avss_vs_vssh": "電源電圧を調整してください。{outVsmLabel}は、{inVsmLabel}を30V以上超えてはいけません。",
    "error_gain": "ゲインを調整してください。ゲインは、{partNumber} の仕様で決められている {bottomRange} ~ {topRange} である必要があります。",
    "error_output_supply_range": "電源電圧を調整してください。電源電圧({outVspLabel} - {outVsmLabel})は、規格の動作範囲{partNumber} - {minRange}V～{maxRange}Vの内側でなければなりません。",
    "error_vcms": "{partNumber} は指定の電源電圧で動作しません。出力電圧が使用可能な電源電圧を超えています。下記をお試しください。<ul><li> 入力信号を減らす </li><li> 電源電圧を増やす </li></ul>",
    "error_vddcp": "電圧の設定値を調整してください。{vddcpLabel}は、{partNumber}の指定された電源電圧範囲（{min}V～{max}V）でなければなりません",
    "error_voltage_supplies": "電源電圧を調整してください。電源範囲({vsPosLabel} - {vsNegLabel}) は、{partNumber} の仕様範囲である {minRange}V ~ {maxRange}V の間である必要があります。",
    "error_vouts": "{partNumber} は指定の電源電圧で動作しません。出力電圧が使用可能な電源電圧を超えています。下記をお試しください。<ul><li> 入力信号を減らす </li><li> ゲインを減らす </li><li> 電源電圧を増やす </li><li> {vrefLabel} 値を変更する </li></ul>",
    "error_vposout_vs_vposin": "電源電圧を調整してください。{vPosOutLabel}は、{vPosInLabel}と同じかそれ以下でなければなりません。",
    "error_vref": "{vrefLabel} 値を調整してください。{partNumber} で電源電圧の値が {vsPosLabel} = {vsTop}V、{vsNegLabel} = {vsBottom}V の場合、{vrefLabel} 値は {minRange}V から {maxRange}V にする必要があります。",
    "error_vref_pins": "REFピン入力を調整してください。(REF2 - REF1)は、{vrefSpan}Vを越えてはいけません。",
    "gainValOne": "ゲインを調整してください。ゲインは、{partNumber} の許容範囲の値である必要があります。",
    "invalidChar": "この欄は数字入力が必要",
    "recommendedOne": "計装アンプを変更する:推奨製品が ",
    "recommendedTwo": " つあります"
  },
  "signalConfig": {
    "v": "V"
  },
  "tabs": {
    "internal": "内部ブロック図",
    "polygon": "ダイヤモンド・プロット",
    "recommended": "推奨",
    "test": "Test"
  },
  "test": {
    "againstGold": "Validate Against Gold",
    "generateGold": "Generate Gold Standard"
  },
  "title": "計装アンプ・ダイヤモンド・プロット・ツール",
  "typeDifferential": "Vcm",
  "typeDifferentialDescription": "差動",
  "typeSingleEndedNeg": "Vp",
  "typeSingleEndedNegDescription": "シングルエンド V-",
  "typeSingleEndedPos": "Vn",
  "typeSingleEndedPosDescription": "シングルエンド V+"
}], ["zh-cn", {
  "adi-logo": "Analog Devices Logo",
  "ember-aditools-page": {
    "card": {
      "checkbox-tooltip": "Toggle",
      "help-tooltip": "Click for help",
      "part-number-tooltip": "Click to select part"
    },
    "common": {
      "cancel": "取消",
      "close": "关闭",
      "load": "加载",
      "ok": "确定",
      "open": "打开",
      "save": "保存",
      "select": "选择"
    },
    "dialogs": {
      "feedback": {
        "email": "电子邮件：",
        "feedback": "你的反馈：",
        "give-feedback": "给予反馈",
        "invitation": "请告诉我们你对这款工具的看法，任何好的或坏的。 ",
        "name": "姓名：",
        "optional": "(Optional)",
        "title": "提交您的意见或反馈！"
      },
      "load": {
        "choose-button": "选择文档",
        "message": "从计算机文件中加载设计",
        "no-file-selected": "No file selected.",
        "title": "加载设计"
      },
      "samples": {
        "add-button": "添加所选样片至购物车",
        "add-link": "Add to Order",
        "add-to-cart-column": "样片加入购物车",
        "model-column": "元器件模型/封装",
        "part-column": "组成部分",
        "quantities-warning": "ADI公司向符合条件的客户免费限量提供样片。 出于客户对我们产品样片有大量需求，两周内，每款器件您只能申请2片，每份申请最多申请4款器件。 如果您的设计需要额外数量的产品，请在网站上通过在线购买或者联系我们的授权代理商购买。",
        "title": "申请样片",
        "unavailable-message": "无法申请样片"
      },
      "save": {
        "save-desc-error": "请提供描述",
        "save-desc-field": "介绍",
        "save-name-error": "请输入设计名称",
        "save-name-field": "设计名称",
        "title": "保存"
      },
      "share": {
        "share-button": "Email",
        "share-design-information": "<p>若要共享您的设计副本，请在 <b>发件人名称</b> 字段中输入您的姓名。然后在 <b>共享设计</b> 字段中输入收件人的电子邮件地址。多个收件人的地址需分行填写。</p><p>收件人将收到ADI发出的电子邮件，内含包括共享设计ZIP存档的附件。您只需要从ZIP文件中提取设计并使用应用的“加载设计”功能上传。</p><p>本过程为每个收件人创建一份设计副本。收件人编辑他们的副本并不会影响您保存在您自己的电脑中的设计。</p>",
        "share-dialog-ng-message": "无法共享设计，这可能是因为服务器连接问题。请重试。",
        "share-dialog-ok-message": "已共享设计",
        "share-duplicate-email": "找到重复的电子邮件",
        "share-email-empty-error": "请输入电子邮件地址",
        "share-email-field": "收件人",
        "share-email-format-error": "您输入的电子邮件地址中有一个或多个无效，请更正后重试。",
        "share-email-placeholder": "电子邮件地址",
        "share-name-error": "请输入设计名称",
        "share-name-field": "设计名称",
        "share-sender-error": "请提交收件人姓名",
        "share-sender-field": "收件人姓名",
        "title": "通过邮件发送我的设计"
      },
      "system": {
        "application-busy": "处理中...",
        "title": "应用消息"
      }
    },
    "footer": {
      "accessibility": "可访问性",
      "cookie-settings": "Cookie设置",
      "copyright-text": "1995 - 2025 Analog Devices, Inc. 保留所有权利",
      "icp-id": "<a href=\"https://beian.miit.gov.cn/\">沪ICP备09046653号-1</a>",
      "legal": "法律与风险",
      "privacy-policy": "隐私政策",
      "privacy-settings": "隐私设置",
      "sitemap": "网站地图"
    },
    "header": {
      "applications": "应用",
      "company": "公司",
      "design-center": "设计中心",
      "education": "教育培训",
      "parametric-search": "参数搜索",
      "products": "产品",
      "spoken": {
        "homepage": "ADI主页",
        "sitelinks": "ADI网站链接"
      },
      "support": "支持"
    },
    "menubar": {
      "chinese": "简体中文",
      "english": "English",
      "help": "帮助",
      "japanese": "日本語",
      "load": "加载设计",
      "save": "保存"
    },
    "studio": {
      "adcdriver": "ADC驱动器",
      "dacebc": "DAC",
      "diamond": "仪表放大器",
      "filterwizard": "模拟滤波器",
      "noise": "噪声",
      "photodiode": "光电二极管",
      "precisionstudio": "ADI<span class=''service-mark''>℠</span> Precision Studio",
      "signalchaindesigner": "Signal Chain",
      "simdds": "DDS",
      "spoken": {
        "studiolinks": "ADI Precision Studio链接"
      },
      "virteval": "Virtual Eval"
    },
    "toolbar": {
      "actions": "Actions"
    }
  },
  "expandedParameterView": {
    "bw": "BW (Hz)",
    "cmrr": "CMRR (dB)",
    "description": "描述",
    "expand": "展开视图",
    "iosMax": "Ios Max (A)",
    "isyMaxPerAmp": "每个放大器ISupply (A) ",
    "name": "部件",
    "new-window": "新建窗口",
    "noiseDensity": "噪声密度(V/√Hz) ",
    "summaryText": "'{count, plural, =0 {显示#/{total} 个仪表放大器的数量，请查看筛选结果。} other {显示#/{total} 个仪表放大器的数量。}}'",
    "validGains": "有效增益",
    "vos": "Vos RTI (V)"
  },
  "gridErrorMsg": {
    "errorMsg": "没有与左侧面板中设置兼容的仪表放大器。 调整电源、增益和输入信号设置，并使用钻石图视图以确保输入信号在仪表放大器的工作范围内。 ",
    "post": "发布有关设计规格和钻石图工具的问题。",
    "site": "ez.analog.com/community/design-tools-and-calculators",
    "visit": "请访问"
  },
  "hamburgerMenu": {
    "applications": "应用",
    "community": "中文技术论坛",
    "designCenter": "设计资源",
    "education": "教育",
    "parametricSearch": "参数搜索",
    "products": "产品",
    "support": "支持"
  },
  "headerIcons": {
    "feedback": "反馈",
    "help": "帮助",
    "share": "共享",
    "undo": "返回100%"
  },
  "help": {
    "help": {
      "header": "使用钻石图工具",
      "message": "<div class=\"help-dialog--standard\"><h3 class=\"dialog-title\"><a href=\"{siteUrl}/{adiLocale}/product-category/instrumentation-amplifiers\" target=\"_blank\" rel=\"noopener noreferrer\">什么是仪表放大器？</a></h3><h3 class=\"dialog-title\"><a href=\"https://www.youtube.com/watch?v=VSf31DaXWUE\" target=\"_blank\" rel=\"noopener noreferrer\">我需要关于该图的更多背景知识</a> (video)<p></p></h3><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">该工具是做什么的？</h3></p><p>仪表放大器数据手册通常显示输出摆幅与输入共模电压的一个关系图（或几个变化形式），也被称为钻石图，这是一个所有外部和内部裕量限制综合图。 若有足够的电路基本信息，钻石图还可以针对各种电源电压、收益和参考引脚电压条件进行调整。</p><p>钻石图能够调整固然好，但是更重要的是能够确定目标信号是否在钻石图限制范围内。 这需要提供输入信号信息。 输入信号范围直接绘制在钻石图上，输入信号超过钻石图边界的任何错误都会显示在图中并且由工具报错。</p><p>对于任何电路配置，工具都会提供一个推荐的仪表放大器列表。 这些推荐器件满足钻石图的要求以及电源电压范围、REF引脚电压范围和增益范围，因此它们会如文中所述在电路中工作。 该列表可以在工具中或在analog.com参数表中进一步筛选。在设计中使用该工具，可以在几分钟内选择仪表放大器，而不是几小时，并具有极高的可信度。</p><p>最后，可提供一个简化版的内部电路，以便设计人员了解仪表放大器的内部工作情况，以及找出具体的饱和器件。 可以通过滑块调整输入信号范围内显示的电压。</p><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">如何使用这款工具？</h3></p><p>设置： 在电路配置面板中，从下拉列表中选择一个产品，并输入电路条件，如电源电压、基准引脚电压和增益。 选择输入信号范围，包括元件容差和共模引起的预期变化，或设计中必须考虑的差分失调。</p><p>输入信号： 输入共模电压定义为两个输入电压的平均值： VCM = (V+IN + V-IN) / 2。因此单端输入信号（一端输入电压固定，另一端变化）会随差分电压而改变共模电压。 从下拉列表中，选择全差分或单端输入信号。 如果选择单端输入信号，是变化的正输入（例如一个负引脚端接地热电偶），还是变化的负输入（例如检测较小电压轨上的高端电流）。</p><p>后续步骤： 如果电路中有错误，该工具也会显示出来。 若有可用的替代产品，会显示在推荐选项卡下，也可显示在产品选择下拉菜单中。 若没有，则调整电路直到达到工作配置。</p><p>如果选择一个产品，可使用推荐选项卡对推荐列表进行筛选和排序。 通过提供的链接可访问产品页面和数据手册。</p><p>如果使用内部电路选项卡，可通过移动滑块，将显示点的共模和差分电压调整到输入信号范围内的任何电压。</p></div>"
    },
    "importantShapes": {
      "header": "如何使用图表？",
      "message": "<div class=\"help-dialog--standard\"><p>该工具的钻石图会显示许多形状和边界。 形状集合可分为两组-工作范围和设备限制。</p><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">工作范围</h3></p><p>在钻石图中，工作范围可用一个方框表示，方框内是电路预期工作的所有电压范围。 工作范围限制由输入信号和仪表放大器的增益计算得到。按照共模电压（Vcm）与输出电压（Vout）两坐标轴绘制。 两组坐标值可以绘制成范围（最小和最大值）或单个值。 如钻石图工具中的红色方框所示。</p><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">设备限制</h3></p><p>钻石图中其余形状的图形表示设备的工作限制。 每个形状代表选定仪表放大器的特定部分限制，图中所有这些形状的重叠区域表示选定设备正常工作的Vcm与Vout关系区域。</p><p>这个“有效”的工作区域在钻石图工具中为白色，而“无效”工作区域为灰色。</p><p>当工作范围形状（红色）在有效工作区（白色区域）边界内，这表明所选择的设备在指定条件（电源电压、基准电压、增益、输入信号）下将按预期工作。</p><p>当工作范围形状在有效工作区外（并扩展到灰色区域），这表明所选择的设备在指定的电源电压、基准电压、增益、输入信号下将无法按预期工作。</p></div>",
      "popupLink": "如何使用图表？"
    },
    "share": {
      "blog": "仪表放大器支持社区",
      "copy": "Copied ",
      "copyFail": "Copying failed ",
      "copyToClipboard": "复制到剪贴板",
      "p1": "将此链接复制到剪贴板 ",
      "p2": "将其粘贴到电子邮件、EngineerZone®论坛或社交媒体帖子 ",
      "subHeader1": "轻松分享仪表放大器配置！",
      "subHeader2": "需要仪表放大器建议？ 请查看EngineerZone®"
    }
  },
  "inputMain": {
    "circuitHeader": "电路配置",
    "done": "完成",
    "enable": "允许范围",
    "gain": {
      "default": "增益",
      "input": "输入增益",
      "output": "输出调整增益",
      "total": "总增益 = "
    },
    "gainFixed": "固定增益",
    "reset": "默认设置",
    "signalHeader": "输入信号",
    "to": "to",
    "vclhi": "CLHI",
    "vcllo": "CLLO",
    "vdiff": "Vdiff:",
    "voltage": "V",
    "vref": "Vref",
    "vref1": "REF1",
    "vref2": "REF2",
    "vsn": "-Vs",
    "vsp": "+Vs"
  },
  "internalCircuitry": {
    "vDiff": "Vdiff = ",
    "vNeg": "V-",
    "vPos": "V+",
    "vPosOut": "V+OUT",
    "voltage": "V"
  },
  "internalValidation": {
    "error_subtractIn_high": "{type} 超出减法器上限：{high}",
    "error_subtractIn_low": "{type} 超出减法器下限：{low}",
    "error_vIH": "{type} 超出vIH限制：{vIH}",
    "error_vIL": "{type} 超出vIL限制：{vIL}",
    "error_vOH": "{voutLabel} 超出vOH限制：{vOH}",
    "error_vOL": "{voutLabel} 超出vOL限制：{vOL}",
    "error_vinGainMax_high": "{type} 超出前置放大器上限：{preAmpHigh}",
    "error_vinGainMin_low": "{type} 超出前置放大器下限：{preAmpLow}"
  },
  "legend": {
    "differentailLimits": "差分输入限制",
    "feedbackLimits": "反馈引脚限制",
    "inputLimits": "输入引脚限制",
    "internalLimits": "内部节点限制",
    "legend": "图例",
    "operatingRange": "工作范围",
    "outputLimits": "输出引脚限制",
    "outputPinA1": "输出引脚和A1限制 "
  },
  "modals": {
    "close": "关闭",
    "feedback": {
      "cancel": "取消",
      "email": "电子邮件：",
      "feedback": "你的反馈：",
      "feedbackDialogNgMessage": "您的反馈发送失败。可能是由于服务器的连接问题，请尝试再次发送。",
      "feedbackDialogOkMessage": "您的反馈已经发送。",
      "give-feedback": "给予反馈",
      "header": "提交您的意见或反馈！",
      "id": "feedback-survey",
      "invitation": "请告诉我们你对这款工具的看法，任何好的或坏的。 ",
      "name": "姓名：",
      "optional": "(Optional)"
    },
    "plot-boundaries": {
      "header": "绘图边界已失效",
      "message": "请发送反馈，表示您已经收到这条信息，并包含当前URL"
    },
    "system": {
      "applicationBusy": "处理中...",
      "header": "应用消息"
    }
  },
  "new-window": "新建窗口",
  "operatingRangeValidation": {
    "error_polygons": "{partNumber} 在电源电压限值范围内不工作 – 内部节点电压超过了可用电压。 尝试以下操作： <ul><li> 降低输入信号 </li><li> 增大电源电压 </li><li> 降低增益 </li></ul>"
  },
  "partSelector": {
    "gain": "与设置的增益不兼容",
    "range": "输入信号超过器件工作范围",
    "supply": "与设置的电源电压范围不兼容",
    "vref": "设置的Vref超过器件的电源裕量"
  },
  "plotXLabel": "Vout (V) (25C下的典型限制 )",
  "plotXLabelDiff": "Vout Diff (V) (25C下的典型限制 )",
  "plotXLabelDiff3Amp": "Vout Diff (V)",
  "plotYLabel": "Vcm (V)",
  "recommendedInAmps": {
    "all": "查看所有仪表放大器的参数",
    "description": "描述",
    "expandView": "根据规格筛选列表 ",
    "expandedParametricView": "扩展参数视图 ",
    "fixedAndProg1": "固定的可编程仪表放大器可实现非常高的增益精度和低增益漂移",
    "fixedAndProg2": "但是，只有选择了确切的增益，这些仪表放大器才会出现在此列表中可获得的固定增益:",
    "fixedAndProg3": "1, 2, 4, 5, 8, 10, 16, 32, 64, 100, 128, 2000",
    "name": "部件",
    "partsWithGain": "基于",
    "recommended": "查看推荐仪表放大器的参数",
    "recommendedAmps": "根据左面板中指定设置推荐的仪表放大器",
    "reset": "复位",
    "viewParametrics": "",
    "volts": "V/V 增益估计的规格 "
  },
  "schematicOutput": {
    "rg": "Rg",
    "to": " to ",
    "v": "V",
    "vcm": "Vcm",
    "vdiff": "Vdiff",
    "vdiff2": "Vdiff/2",
    "vn": "Vn",
    "vout": "计算的Vout",
    "voutdiff": "计算的Vout（差速器）",
    "vp": "Vp"
  },
  "schematicValidation": {
    "emptyString": "该值不得为空",
    "error_avss_vs_dvss": "{outVsmLabel} 的电压必须与DVSS相同。参见{partNumber}数据手册的\"电源\"和\"ESD映射\"部分。",
    "error_avss_vs_vddh": "请调整电源电压值。{outVsmLabel}不应低于{inVspLabel} 30V以上。",
    "error_avss_vs_vssh": "请调整电源电压值。{outVsmLabel}不应超过{inVsmLabel} 30V以上。",
    "error_gain": "请调整增益值。增益必须在{partNumber}指定的增益限值范围内（{bottomRange}至{topRange}）",
    "error_output_supply_range": "请调整电源电压值。电源电压范围({outVspLabel} - {outVsmLabel})必须在{partNumber}指定的电源电压范围限值内（{minRange}V至{maxRange}V）",
    "error_vcms": "{partNumber} 在电源电压限值范围内不工作 – 输入电压超过了可用电压。 尝试以下操作： <ul><li> 降低输入信号 </li><li> 增大电源电压 </li></ul>",
    "error_vddcp": "请调整电源值。 {vddcpLabel}必须在{partNumber}规定的 {min}V ~ {max}V的供电范围内",
    "error_voltage_supplies": "请调整电源电压值。电源电压范围({vsPosLabel} - {vsNegLabel})必须在{partNumber}指定的电源电压范围限值内（{minRange}V至{maxRange}V）",
    "error_vouts": "{partNumber} 在电源电压限值范围内不工作 – 输出电压超过了可用电压。 尝试以下操作： <ul><li> 降低输入信号 </li><li> 降低增益 </li><li> 增大电源电压 </li><li> 改变{vrefLabel}值 </li></ul>",
    "error_vposout_vs_vposin": "请调整电源电压值。{vPosOutLabel}必须等于或小于{vPosInLabel}",
    "error_vref": "请调整{vrefLabel}值。 对于 {partNumber}，电源值为{vsPosLabel} = {vsTop}V和{vsNegLabel} = {vsBottom}V时，{vrefLabel}必须在 {minRange}V至 {maxRange}V范围内",
    "error_vref_pins": "请调整REF引脚值。(REF2 - REF1)不得大于{vrefSpan}V",
    "gainValOne": "请调整增益值。增益必须是{partNumber}允许的增益值之一",
    "invalidChar": "该值必须是数字",
    "recommendedOne": "更改放大器： 推荐使用 ",
    "recommendedTwo": " 个器件"
  },
  "signalConfig": {
    "v": "V"
  },
  "tabs": {
    "internal": "内部电路",
    "polygon": "钻石图",
    "recommended": "推荐",
    "test": "Test"
  },
  "test": {
    "againstGold": "Validate Against Gold",
    "generateGold": "Generate Gold Standard"
  },
  "title": "仪表放大器钻石图工具",
  "typeDifferential": "Vcm",
  "typeDifferentialDescription": "差分",
  "typeSingleEndedNeg": "Vp",
  "typeSingleEndedNegDescription": "单端V- ",
  "typeSingleEndedPos": "Vn",
  "typeSingleEndedPosDescription": "单端V+ "
}], ["ru-ru", {
  "adi-logo": "Analog Devices Logo",
  "ember-aditools-page": {
    "card": {
      "checkbox-tooltip": "Toggle",
      "help-tooltip": "Click for help",
      "part-number-tooltip": "Click to select part"
    },
    "common": {
      "cancel": "Cancel",
      "close": "Close",
      "load": "Load",
      "ok": "OK",
      "open": "Open",
      "save": "Save",
      "select": "Select"
    },
    "dialogs": {
      "feedback": {
        "email": "EMail: ",
        "feedback": "Your Feedback",
        "give-feedback": "Tell us",
        "invitation": "Please let us know your opinion of this tool, good and bad.",
        "name": "Name: ",
        "optional": "(Optional)",
        "title": "Give us your feedback!"
      },
      "load": {
        "choose-button": "Choose File",
        "message": "Load a design from a file on your computer.",
        "no-file-selected": "No file selected.",
        "title": "Load Design"
      },
      "samples": {
        "add-button": "Add Selected Samples to Cart",
        "add-link": "Add to Order",
        "add-to-cart-column": "Add Sample to Cart",
        "model-column": "Device Model/Package",
        "part-column": "Device Name",
        "quantities-warning": "Analog Devices offers a limited amount of free samples to qualified customers. Due to the large demand for our product samples we ask that you limit your sample request to 2 pieces per part with a maximum of 4 parts per request within a 14 day time period. Should your design needs require additional product quantities, you can purchase them on the web through Buy Online, or you can contact one of our authorized distributors.",
        "title": "Order Samples",
        "unavailable-message": "Not available for sample"
      },
      "save": {
        "save-desc-error": "Please provide a Description",
        "save-desc-field": "Description",
        "save-name-error": "Please provide a Design Name",
        "save-name-field": "Design Name",
        "title": "Save Design"
      },
      "share": {
        "share-button": "Email",
        "share-design-information": "<p>To share a copy of your design, enter your name into the <b>Sender name</b> field. Then enter the email address of the recipients in the <b>Share design with</b> field.</p><p>The recipients will receive an email from Analog Devices with an attachment containing a ZIP archive of the shared design. All you have to do is extract the design from the ZIP file and upload it using the Load Design functionality of the application</p><p>This process creates a copy of the design for each recipient. If recipients choose to make edits on their copies, it will have no effect on your design you saved to your own computer.</p>",
        "share-dialog-ng-message": "Unable to share design. This is likely due to a server connection error. Please try again.",
        "share-dialog-ok-message": "Design has been shared",
        "share-duplicate-email": "Duplicate emails found",
        "share-email-empty-error": "Please enter an email address",
        "share-email-field": "Share design with",
        "share-email-format-error": "At least one of the email addresses you entered is invalid. Please correct and try again",
        "share-email-placeholder": "Email Address",
        "share-name-error": "Please provide a Design Name",
        "share-name-field": "Design Name",
        "share-sender-error": "Please provide a Sender Name",
        "share-sender-field": "Sender Name",
        "title": "Share My Design"
      },
      "system": {
        "application-busy": "Working...",
        "title": "Application Message"
      }
    },
    "footer": {
      "accessibility": "Accessibility",
      "cookie-settings": "Cookie Settings",
      "copyright-text": "1995 - 2025 Analog Devices, Inc. All Rights Reserved",
      "icp-id": "",
      "legal": "Legal and Risk",
      "privacy-policy": "Privacy Policy",
      "privacy-settings": "Privacy Settings",
      "sitemap": "Sitemap"
    },
    "header": {
      "applications": "Applications",
      "company": "Company",
      "design-center": "Design Center",
      "education": "Education",
      "parametric-search": "Parametric Search",
      "products": "Products",
      "spoken": {
        "homepage": "ADI Home Page",
        "sitelinks": "ADI Site Links"
      },
      "support": "Support"
    },
    "menubar": {
      "chinese": "简体中文",
      "english": "English",
      "help": "Help",
      "japanese": "日本語",
      "load": "Load Design",
      "save": "Save"
    },
    "studio": {
      "adcdriver": "ADC Driver",
      "dacebc": "DAC",
      "diamond": "In Amp",
      "filterwizard": "Analog Filter",
      "noise": "Noise",
      "photodiode": "Photodiode",
      "precisionstudio": "ADI<span class=''service-mark''>℠</span> Precision Studio",
      "signalchaindesigner": "Signal Chain",
      "simdds": "DDS",
      "spoken": {
        "studiolinks": "ADI Precision Studio Links"
      },
      "virteval": "Virtual Eval"
    },
    "toolbar": {
      "actions": "Actions"
    }
  },
  "expandedParameterView": {
    "bw": "BW (Гц)",
    "cmrr": "КОСС (дБ)",
    "description": "Описание",
    "expand": "Expand view",
    "iosMax": "Ios Max (A)",
    "isyMaxPerAmp": "Потребляемый ток на канал усилителя (A)",
    "name": "Компонент",
    "new-window": "New window",
    "noiseDensity": "Плотность шума (В/√Гц)",
    "summaryText": "'{count, plural, =0 {Displaying # of {total} op amps. Please check the filters provided.} other {Displaying # of {total} in amps.}}'",
    "validGains": "Коэффициент усиления",
    "vos": "Vos RTI (В)"
  },
  "gridErrorMsg": {
    "errorMsg": "Инструментальных усилителей, соответствующих характеристикам, заданным на панели слева, не найдено. Установите значения напряжения питания, коэффициента усиления и входного сигнала, и определите по таблице Diamond Plot, что входной сигнал попадает в рабочий диапазон инструментального усилителя. ",
    "post": "",
    "site": "ez.analog.com/community/design-tools-and-calculators",
    "visit": "Чтобы задать вопрос, связанный с характеристиками вашего проекта и инструментом проектирования Diamond Plot, посетите "
  },
  "hamburgerMenu": {
    "applications": "Применение",
    "community": "Форум",
    "designCenter": "Ресурсы",
    "education": "Обучение",
    "parametricSearch": "Поиск",
    "products": "Продукты",
    "support": "Поддержка"
  },
  "headerIcons": {
    "feedback": "Обратная связь",
    "help": "Помощь",
    "share": "Поделиться",
    "undo": "Возврат к 100%"
  },
  "help": {
    "help": {
      "header": "Работа с инструментом Diamond Tool",
      "message": "<div class=\"help-dialog--standard\"><h3 class=\"dialog-title\"><a href=\"{siteUrl}/{adiLocale}/product-category/instrumentation-amplifiers\" target=\"_blank\" rel=\"noopener noreferrer\">Что такое инструментальный усилитель?</a></h3><h3 class=\"dialog-title\"><a href=\"https://www.youtube.com/watch?v=VSf31DaXWUE\" target=\"_blank\" rel=\"noopener noreferrer\">Мне нужно больше информации об этом графике</a> (видео)<p></p></h3><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">Что делает этот инструмент?</h3></p><p>В технических описаниях инструментальных усилителей обычно приводится график зависимости размаха выходного напряжения от входного синфазного напряжения (или несколько его вариаций), также известный как <b>Diamond Plot</b>, который является исчерпывающей характеристикой всех внутренних и внешних предельных рабочих значений. При достаточном объеме базовой информации о схеме <b>Diamond Plot</b> можно подстроить для учета различных значений напряжения питания, коэффициента усиления и опорного напряжения.</p><p>Этот график сам по себе очень информативен, однако по-настоящему ценной информацией является то, попадает ли интересующий сигнал в границы, очерченные графиком <b>Diamond Plot</b>. Чтобы выяснить это, необходимы также данные о входном сигнале. Диапазон входных сигналов откладывается непосредственно на графике <b>Diamond Plot</b>, и инструмент оповещает пользователя о выходах входного сигнала за пределы границ графика.</p><p>Для любой конфигурации схемы инструмент выдает список <b>Рекомендуемых</b> инструментальных усилителей. Эти <b>Рекомендуемые компоненты</b> удовлетворяют требованиям графика <b>Diamond Plot</b>, а также ограничениям на диапазон напряжений питания, диапазон напряжений вывода REF и диапазон коэффициентов усиления, поэтому при использовании в составе схемы реальные характеристики будут соответствовать ожидаемым. Список можно дополнительно отфильтровать при помощи самого инструмента или параметрической таблицы на сайте analog.com. Используя этот инструмент в процессе проектирования, вы можете с высокой степенью уверенности подобрать инструментальный усилитель, потратив на это минуты, а не часы.</p><p>И, наконец, для тех, кому интересно внутренне устройство инструментальных усилителей и механизмы насыщения, инструмент позволяет посмотреть упрощенную версию <b>Внутренней схемы</b>. Вы можете воспользоваться регулятором полосы прокрутки для установки отображаемого напряжения в пределах введенного диапазона напряжений сигнала.</p><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">Как использовать этот инструмент?</h3></p><p><ins>Конфигурирование</ins>: На вкладке <b>Конфигурация схемы</b> выберите продукт из выпадающего списка и введите рабочие условия для схемы, включая напряжение питания, опорное напряжение и коэффициент усиления. Задайте диапазон входного сигнала с учетом любых отклонений, которые могут быть вызваны допусками компонентов, а также смещением синфазных или дифференциальных напряжений.</p><p><ins>Входной сигнал</ins>: Входное синфазное напряжение по определению равно среднему от двух входных напряжений: V<sub>CM</sub> = (V<sub>+IN</sub> + V<sub>-IN</sub>)/2. Поэтому у несимметричных сигналов, для которых напряжение на одном из входов фиксировано, синфазное напряжение будет изменяться одновременно с дифференциальным напряжением. В выпадающем списке вы можете выбрать тип входного сигнала (полностью дифференциальный или несимметричный). Для несимметричного сигнала можно выбрать, напряжение на каком из входов является переменным – на положительном входе (например, при работе с термопарой, когда отрицательный вход заземлен), или на отрицательном входе (например, при измерении тока в цепи высокого напряжения).</p><p><ins>Следующие шаги</ins>: При нахождении каких-либо ошибок в схеме инструмент выдаст оповещение. Возможно, для вашего варианта имеются подходящие альтернативные продукты, которые показаны на вкладке <b>Рекомендуемые компоненты</b>, а также в выпадающем меню выбора продукта. В противном случае вам необходимо отрегулировать параметры схемы, пока не будет получена работоспособная конфигурация.</p><p>При выборе продукта используйте вкладку <b>Рекомендуемые компоненты</b> для фильтрации и сортировки списка <b>Рекомендуемых компонентов</b>. По приведенным ссылкам вы можете перейти к страницам конкретных продуктов и техническим описаниям.</p><p> При работе с вкладкой <b>Внутренняя схема</b> вы можете управлять синфазным и дифференциальным напряжением в пределах диапазона входных напряжений сигнала, используя регулятор полосы прокрутки.</p></div>"
    },
    "importantShapes": {
      "header": "Как я использую этот график?",
      "message": "<div class=\"help-dialog--standard\"><p>На графике Diamond Plot представлено несколько линий и областей. Их можно разделить на две группы – Рабочий диапазон и Предельные значения.</p><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">Рабочий диапазон</h3></p><p>На графике Diamond Plot рабочий диапазон представлен в виде прямоугольника, охватывающего все значения напряжений, при которых схема может функционировать. Границы рабочего диапазона вычисляются исходя из значений входного сигнала и коэффициента усиления инструментального усилителя. График строится в системе двух координат – зависимость синфазного напряжения (Vcm) от выходного напряжения (Vout). Оба эти значения могут быть представлены в виде диапазона (минимальное и максимальное значения), либо отдельной величиной. Область рабочих значений на графике Diamond Plot выделена красным цветом.</p><p class=\"no-margin-bottom\"><h3 class=\"dialog-title\">Предельные значения параметров устройства</h3></p><p>Остальные линии на графике Diamond Plot описывают предельные значения параметров устройства. Каждая линия обозначает предельные значения отдельного элемента выбранного инструментального усилителя. Область графика, образованная в результате пересечения всех этих линий, ограничивает диапазоны синфазного напряжения (Vcm) и выходного напряжения (Vout, в пределах которых устройство будет функционировать должным образом.</p><p>«Допустимая» рабочая зона на графике Diamond Plot выделена белым цветом, «Недопустимая» - серым.</p><p>Когда линия рабочего диапазона (красная) находится внутри допустимой рабочей зоны (белая область), это означает, что выбранное устройство, при заданных параметрах (напряжение питания, опорное напряжение, коэффициент усиления, входной сигнал) будет функционировать корректно.</p><p>Когда линия рабочего диапазона выходит за пределы допустимой рабочей зоны (и располагается в области серого цвета), это означает, что выбранное устройство при заданных значениях напряжения питания, опорного напряжения, коэффициенте усиления и входного сигнала корректно функционировать не будет.</p></div>",
      "popupLink": "Как я использую этот график?"
    },
    "share": {
      "blog": "Сообщество поддержки по инструментальным усилителям",
      "copy": "Скопировано ",
      "copyFail": "Не удалось копировать ",
      "copyToClipboard": "Скопировать",
      "p1": "1. Скопируйте эту ссылку",
      "p2": "2. Вставьте эту ссылку в электронное письмо, на форуме EngineerZone или в социальной сети",
      "subHeader1": "Поделиться данной конфигурацией инструментального усилителя просто!",
      "subHeader2": "Хотите получить полезную информацию об инструментальных усилителях? Зайдите на EngineerZone®"
    }
  },
  "inputMain": {
    "circuitHeader": "Конфигурация схемы",
    "done": "Done",
    "enable": "Enable range",
    "gain": {
      "default": "КУ",
      "input": "Input Gain",
      "output": "Output Scaling Gain",
      "total": "Total Gain = "
    },
    "gainFixed": " Постоянное усиление",
    "reset": "Значения по умолчанию",
    "signalHeader": "Входной сигнал",
    "to": "to",
    "vclhi": "CLHI",
    "vcllo": "CLLO",
    "vdiff": "Vdiff:",
    "voltage": "V",
    "vref": "Vref",
    "vref1": "REF1",
    "vref2": "REF2",
    "vsn": "-Vs",
    "vsp": "+Vs"
  },
  "internalCircuitry": {
    "vDiff": "Vdiff = ",
    "vNeg": "V-",
    "vPos": "V+",
    "vPosOut": "V+OUT",
    "voltage": "V"
  },
  "internalValidation": {
    "error_subtractIn_high": "{type} falls outside of the subtractor high limit of: {high}",
    "error_subtractIn_low": "{type} falls outside of the subtractor low limit of: {low}",
    "error_vIH": "{type} falls outside of the vIH limit of: {vIH}",
    "error_vIL": "{type} falls outside of the vIL limit of: {vIL}",
    "error_vOH": "{voutLabel} falls outside of the vOH limit of: {vOH}",
    "error_vOL": "{voutLabel} falls outside of the vOL limit of: {vOL}",
    "error_vinGainMax_high": "{type} falls outside of the pre amp high limit of: {preAmpHigh}",
    "error_vinGainMin_low": "{type} falls outside of the pre amp low limit of: {preAmpLow}"
  },
  "legend": {
    "differentailLimits": "Предельные значения дифференциального входного сигнала",
    "feedbackLimits": "Предельные значения для выводов обратной связи",
    "inputLimits": "Предельные значения для входных выводов",
    "internalLimits": "Предельные значения для внутренних узлов",
    "legend": "Обозначения",
    "operatingRange": "Рабочий диапазон",
    "outputLimits": "Предельные значения для выходных выводов",
    "outputPinA1": "Предельные значения для выходного вывода и вывода A1"
  },
  "modals": {
    "close": "Закрыть",
    "feedback": {
      "cancel": "Cancel",
      "email": "EMail: ",
      "feedback": "Your Feedback",
      "feedbackDialogNgMessage": "Failed to send user feedback. This may be due to a poor connection to the server. Please try again.",
      "feedbackDialogOkMessage": "Your feedback has been sent.",
      "give-feedback": "Tell us",
      "header": "Give us your feedback!",
      "id": "feedback-survey",
      "invitation": "Please let us know your opinion of this tool, good and bad.",
      "name": "Name: ",
      "optional": "(Optional)"
    },
    "plot-boundaries": {
      "header": "Plot boundaries have failed",
      "message": "Please send feedback that you received this message and include the current url."
    },
    "system": {
      "applicationBusy": "Working...",
      "header": "Application Message"
    }
  },
  "new-window": "New Window",
  "operatingRangeValidation": {
    "error_polygons": "{partNumber} не работает с указанными предельными значениями напряжений питания – напряжение в одном из внутренних узлов превышает напряжение питания. Попробуйте выполнить следующие действия:<ul><li> уменьшить значение входного сигнала </li><li> увеличить диапазон питания </li><li> уменьшить значение коэффициента усиления </li></ul>"
  },
  "partSelector": {
    "gain": "Не соответствует заданному КУ",
    "range": "Входной сигнал превышает рабочий диапазон",
    "supply": "Не отвечает заданному диапазону питания",
    "vref": "Заданное Vref превышает диапазон питания"
  },
  "plotXLabel": "Vout (В) (типичные пределы при 25˚C).",
  "plotXLabelDiff": "Vout Diff (В) (типичные пределы при 25˚C).",
  "plotXLabelDiff3Amp": "Vout Diff (B)",
  "plotYLabel": "Vcm (В)",
  "recommendedInAmps": {
    "all": "всех инструментальных усилителей",
    "description": "Описание",
    "expandView": "Фильтровать список по характеристикам ",
    "expandedParametricView": "Развернутая таблица характеристик",
    "fixedAndProg1": "Fixed and Programmable in-amps can achieve very high gain accuracy and low gain drift",
    "fixedAndProg2": "but they will only appear in this list if the exact gain is chosen. Fixed gains available:",
    "fixedAndProg3": "1, 2, 4, 5, 8, 10, 16, 32, 64, 100, 128, 2000",
    "name": "Компонент",
    "partsWithGain": "Характеристики рассчитаны для коэффициента усиления ",
    "recommended": "рекомендуемых инструментальных усилителей",
    "recommendedAmps": "Инструментальные усилители, рекомендуемые при характеристиках, заданных в панели слева",
    "reset": "Сброс",
    "viewParametrics": "Посмотреть характеристики  ",
    "volts": "В/В"
  },
  "schematicOutput": {
    "rg": "Rg",
    "to": " to ",
    "v": "В",
    "vcm": "Vcm",
    "vdiff": "Vdiff",
    "vdiff2": "Vdiff/2",
    "vn": "Vn",
    "vout": "Расчетное Vout",
    "voutdiff": "Calculated Vout(diff)",
    "vp": "Vp"
  },
  "schematicValidation": {
    "emptyString": "the value must not be empty",
    "error_avss_vs_dvss": "{outVsmLabel} must be at the same voltage as DVSS. See \"Power Supplies\" and \"ESD Map\" section of {partNumber} datasheet.",
    "error_avss_vs_vddh": "Please adjust the supply values. {outVsmLabel} should not be more than 30V below {inVspLabel}.",
    "error_avss_vs_vssh": "Please adjust the supply values. {outVsmLabel} should not be more than 30V above {inVsmLabel}.",
    "error_gain": "Пожалуйста, исправьте значение коэффициента усиления. Значение коэффициента усиления должно находится в пределах, заданных для {partNumber}, от {bottomRange} до {topRange}",
    "error_output_supply_range": "Please adjust the supply values. The supply range ({outVspLabel} - {outVsmLabel}) must be within the specified supply range limits of the {partNumber} - {minRange}V to {maxRange}V",
    "error_vcms": "{partNumber} не работает с указанными предельными значениями напряжений питания – входное напряжение превышает напряжение питания. Попробуйте выполнить следующие действия:<ul><li> уменьшить значение входного сигнала </li><li> увеличить диапазон питания </li></ul>",
    "error_vddcp": "Please adjust the supply values. {vddcpLabel} must be within the specified supply range limits of the {partNumber} - {min}V to {max}V",
    "error_voltage_supplies": "Пожалуйста, исправьте значение напряжения питания. Диапазон напряжений питания ({vsPosLabel} - {vsNegLabel}) должен находится в пределах, заданных для {partNumber} от - {minRange}В до {maxRange}В",
    "error_vouts": "{partNumber} не работает с указанными предельными значениями напряжений питания – выходное напряжение превышает напряжение питания. Попробуйте выполнить следующие действия:<ul><li> уменьшить значение входного сигнала </li><li> уменьшить значение коэффициента усиления </li><li> увеличить диапазон питания </li><li> изменить значение {vrefLabel} </li></ul>",
    "error_vposout_vs_vposin": "Please adjust the supply values. {vPosOutLabel} must be equal to or lower than {vPosInLabel}",
    "error_vref": "Пожалуйста, скорректируйте значение {vrefLabel}. Для {partNumber}, с напряжениями питания {vsPosLabel} = {vsTop}В и {vsNegLabel} = {vsBottom}В, {vrefLabel} должно быть в пределах от {minRange}В до {maxRange}В",
    "error_vref_pins": "Please adjust the REF pin values. (REF2 - REF1) should not be more than {vrefSpan}V",
    "gainValOne": "Пожалуйста, исправьте значение коэффициента усиления. Значение коэффициента усиления должно быть допустимым для {partNumber}",
    "invalidChar": "the value must be a number",
    "recommendedOne": "другой ИУ: ",
    "recommendedTwo": " рекомендуемые компоненты"
  },
  "signalConfig": {
    "v": "V"
  },
  "tabs": {
    "internal": "Внутренняя схема",
    "polygon": "Diamond Plot",
    "recommended": "Рекомендуется",
    "test": "Test"
  },
  "test": {
    "againstGold": "Validate Against Gold",
    "generateGold": "Generate Gold Standard"
  },
  "title": "Мастер инструментальных усилителей Diamond Plot",
  "typeDifferential": "Vcm",
  "typeDifferentialDescription": "Дифференциальное напряжение",
  "typeSingleEndedNeg": "Vp",
  "typeSingleEndedNegDescription": "Несимметричное отрицательное напряжение ",
  "typeSingleEndedPos": "Vn",
  "typeSingleEndedPosDescription": "Несимметричное положительное напряжение"
}]];